import type { OrganizationPrivacy } from 'models';
import { type ReactNode, useMemo } from 'react';
import { Icon, RoundElement } from 'ui';

type PrivacyInformation = {
  description: string;
  icon: ReactNode;
  name: string;
};

export const useGetOrganizationPrivacyInformation = ({
  privacy,
}: {
  privacy: OrganizationPrivacy;
}): PrivacyInformation =>
  useMemo(() => {
    switch (privacy) {
      case 'public':
        return {
          description: 'Any member can join',
          icon: (
            <RoundElement size="extra-small">
              <Icon color="text" icon="earth-line" />
            </RoundElement>
          ),
          name: 'Public',
        };
      case 'secret':
        return {
          description: 'Member must be invited to be able to join',
          icon: (
            <RoundElement size="extra-small">
              <Icon color="text" icon="mail-line" />
            </RoundElement>
          ),
          name: 'Secret',
        };
    }
  }, [privacy]);
